/* eslint-disable no-underscore-dangle */
window.OneTrust = window.OneTrust || {}
window.OnetrustActiveGroups = window.OnetrustActiveGroups || ''
window.__tcfapi = window.__tcfapi || null

const getActivePreferences = () => window.OnetrustActiveGroups && window.OnetrustActiveGroups.split(',').filter(group => group)

const isPreferenceExpressed = () => (
  window.tcData
  && window.tcData.cmpStatus === 'loaded'
  && (window.tcData.eventStatus === 'useractioncomplete' || window.tcData.eventStatus === 'tcloaded')
)

const openPreferences = () => window.OneTrust && window.OneTrust.ToggleInfoDisplay()

const initOneTrust = ({
  domain,
  lang,
  onActivationDone,
  onReady,
}) => {
  window.OptanonWrapper = function () {
    window.OneTrust.changeLanguage(lang)
    window.__tcfapi('addEventListener', 2, (tcData, success) => {
      // considering that OptanonWrapper is run every time an action to cookie consent is triggered,
      // we need to remove the listener every time the callback is called
      window.__tcfapi('removeEventListener', 2, () => {}, tcData.listenerId)

      if (!success) return

      window.tcData = tcData

      // OT is loaded for the first time (consent not given yet)
      if (tcData.cmpStatus === 'loaded' && tcData.eventStatus === 'cmpuishown') {
        onReady()
      }

      // OT is loaded NOT for the first time (consent accepted/rejected)
      if (tcData.eventStatus === 'tcloaded') {
        onReady()
        onActivationDone()
      }

      // user completed a cookie action (preference changed) -> onPreferenceExpressedOrNotNeeded
      if (tcData.cmpStatus === 'loaded' && tcData.eventStatus === 'useractioncomplete') {
        onActivationDone()
      }
    })
  }

  const oneTrustStubLibraryScript = document.createElement('script')
  oneTrustStubLibraryScript.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js'
  oneTrustStubLibraryScript.type = 'text/javascript'
  oneTrustStubLibraryScript.charset = 'UTF-8'
  oneTrustStubLibraryScript.setAttribute('data-domain-script', domain)

  document.getElementsByTagName('body')[0].appendChild(oneTrustStubLibraryScript)
}

export {
  initOneTrust,
  isPreferenceExpressed,
  getActivePreferences,
  openPreferences,
}
